import React from "react";
import CSSModules from "react-css-modules";
import styles from "../cardMakeAPayment.scss";
import PropTypes from "prop-types";
import classNames from "classnames";

@CSSModules(styles, { allowMultiple: true })
class PaymentMethodSelect extends React.Component {
  static propTypes = {
    last4Digits: PropTypes.string,
    selected: PropTypes.string,
    onChange: PropTypes.func,
    showCurrent: PropTypes.bool
  };

  handleOnClick = event => {
    const { value } = event.target;
    this.props.onChange(value);
  };

  renderOtherPaymentMethdTypeDisclaimer() {
    return (
      <div styleName="disclaimer" data-at="rcc-disclaimer-text">
        Online payments can only be made using a debit card. <br />
        Please{" "}
        <a href="https://sunbit.com/c_contact.html" target="_blank">
          contact us
        </a>{" "}
        if you want to use a different payment method
      </div>
    );
  }

  render() {
    const options = [
      {
        value: "CURRENT",
        text: `Current Payment Method (ending in ${this.props.last4Digits})`,
        visible: this.props.showCurrent
      },
      {
        value: "NEW",
        text: "Add Debit Card",
        className: "withArrow",
        visible: true
      }
    ];
    return (
      <ul styleName="paymentMethods" data-at={`payment-methods-list`}>
        {!this.props.showCurrent &&
          this.renderOtherPaymentMethdTypeDisclaimer()}
        {options.map(option => {
          if (!option.visible) {
            return;
          }
          const selected = option.value === this.props.selected;
          return (
            <li
              styleName="paymentMethod"
              key={option.value}
              data-at="payment-methods-item"
            >
              <label
                styleName={classNames(option.className, { selected })}
                data-at={`payment-method-${option.value}-label`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={option.value}
                  checked={selected}
                  onChange={this.handleOnClick}
                  data-at={`payment-method-${option.value}-input`}
                />
                {option.text}
              </label>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default PaymentMethodSelect;



// WEBPACK FOOTER //
// ./src/card/makeAPayment/PaymentMethodSelect.js